const FEATURES = [
  {
    title: '下拉式漫画阅读',
    desc: '像刷社交媒体一样阅读漫画。手指下滑，内容连续呈现，无需反复点击翻页。长篇漫画一口气读完，丝滑流畅不卡顿。',
    icon: 'ri-scroll-to-bottom-line',
  },
  {
    title: '经典翻页漫画',
    desc: '还原纸质漫画翻页的真实触感。适合喜欢传统阅读节奏的读者，每翻一页都有仪式感，章节切换自然流畅。',
    icon: 'ri-book-2-line',
  },
  {
    title: '无弹窗漫画',
    desc: '彻底告别弹窗广告、悬浮按钮和插屏提示。纯净画面从头看到尾，不再有突如其来的打断，专注享受故事本身。',
    icon: 'ri-forbid-2-line',
  },
  {
    title: '漫画全屏观看',
    desc: '一键进入全屏沉浸模式，画面充满整块屏幕。支持横屏自动适配，大画幅跨页场景完美呈现，影院级追漫体验。',
    icon: 'ri-fullscreen-line',
  },
  {
    title: '多端同步阅读',
    desc: '桌面端、平板、手机无缝切换。阅读进度自动同步，在家用大屏看跨页大场面，出门用手机继续下拉追更。',
    icon: 'ri-device-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex w-12 h-12 rounded-2xl bg-accent-100 items-center justify-center mb-4">
            <i className="ri-star-line text-accent-600 text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">阅读特色</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            四种核心阅读模式，满足不同场景下的追漫需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200 rounded-2xl p-6 md:p-7 hover:border-primary-300 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 rounded-2xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${f.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2.5">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-foreground-400">
            以上全部阅读模式均支持<strong className="text-foreground-600">免费在线阅读</strong>，无需注册即可使用
          </p>
        </div>
      </div>
    </section>
  );
}